const stripHtml = html => html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')

export default stripHtml
